import Modal from "common/components/Modal/Modal"
import { getApprovalItem } from "features/User/redux/selectors/approvalsSelectors"
import { fetchAprovalById } from "features/User/redux/slices/approvalSlices"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import NewApprovalForm from "./NewApprovalForm"

const AprovalsModal = ({ show, setShow, sendRequest }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const aprobacionItem = useSelector(getApprovalItem)
  const dispatch = useDispatch()

  useEffect(() => {
    show.id && dispatch(fetchAprovalById(show.id))
  }, [dispatch, show.id])

  return (
    <Modal
      header={
        show.id
          ? `${t("flujoAprobaciones.editFlow")}`
          : `${t("flujoAprobaciones.newFlow")}`
      }
      visible={show.status}
      onHide={setShow}
      size='default'
      className='departaments-modal'
    >
      <NewApprovalForm
        // @ts-expect-error TS(2322): Type '{ hideModal: $TSFixMe; flowData: $TSFixMe; sendRequest...
        hideModal={setShow}
        flowData={show.id ? aprobacionItem : {}}
        sendRequest={sendRequest}
        onHide={setShow}
        isEditModal={Boolean(show.id)}
        t={t}
      />
    </Modal>
  )
}

export default AprovalsModal
